// Error codes from apis
export const INVALID_TOKEN_CODE = 4010;
export const SUCCESS_CODE = 1;
export const ERROR_OCCURED = -99;
export const SERVER_ERROR = 500;
export const FORBIDDEN = 403;
export const SESSION_EXPIRED = 401;
export const SEARCH_LIMIT = 400;
export const TIMEOUT_ERROR = 408;
export const SERVICE_UNAVAILABLE = 503;
